<div class="file-repository-section" *ngIf="files">
  <h2 mat-dialog-title>File Repository</h2>

  <mat-tab-group>
    <mat-tab *ngFor="let fileGroup of files" [label]="fileGroup.key">
      <table class="file-repository-table">
        <thead>
        <tr>
          <th>Name</th>
          <th>Status</th>
          <th>Type</th>
          <th *ngIf="fileGroup.key == 'OUTGOING'">Destination</th>
          <th *ngIf="fileGroup.key != 'OUTGOING'">Origin</th>
          <th>Tags</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let file of fileGroup.value">
          <td class="file-name">{{ file.name }}</td>
          <td><status status="{{file.status}}" /></td>
          <td><span class="type">{{ transform(file.type) }}</span></td>
          <td *ngIf="file.outgoing">{{ file.destination }}</td>
          <td *ngIf="!file.outgoing">{{ file.origin }}</td>
          <td>
            <div *ngFor="let tag of file.tags" class="tag-panel">
              <strong>{{ transform(tag.key) }} : </strong>
              <span>{{ tag?.values?.join(',') }}</span>
              <br />
            </div>
          </td>
          <td>
            <a class="action-button" (click)="handleClickAction('download', file)">DOWNLOAD</a>
            <a *ngIf="fileGroup.key == 'OUTGOING'" class="action-button" (click)="handleClickAction('redeliver', file)">RE-POST</a>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="showPrompt" class="repost-prompt">
        <strong>Repost File Confirmation - </strong>Are you sure you want to repost the file <strong>{{repostFile.name}}</strong>? It will be sent again to <strong>{{repostFile.destination}}</strong>.<br /><br />

        This action cannot be undone, and {{repostFile.destination}} may process the file immediately upon receipt.<br />
        <div class="buttons">
          <a class="cancel-button" (click)="handleClickAction('redeliver-cancel', repostFile)">CANCEL</a>
          <a class="confirm-button" (click)="handleClickAction('redeliver-confirm', repostFile)">CONFIRM</a>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <!-- Action Buttons -->
  <div mat-dialog-actions class="action-buttons">
    <button mat-button (click)="onCloseClick()">Close</button>
  </div>
</div>
